<span
    class="anc-tooltip-bubble"
    [class.anc-tooltip-bubble--selectable]="selectable()"
    [class.anc-tooltip-bubble--top]="placement() === 'top'"
    >{{ text() }}</span
>
